import { render, staticRenderFns } from "./EducationInfoForm.vue?vue&type=template&id=bb1dc006&"
import script from "./EducationInfoForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EducationInfoForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EducationInfoForm.vue?vue&type=style&index=0&id=bb1dc006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports